<template>
  <div class="form campaign">
    <el-divider></el-divider>
    <el-form
      ref="form"
      label-width="240px"
      label-position="left"
      :model="formData"
      :rules="rules"
    >
      <el-form-item :label="language('shopCampaign.code')" prop="code">
        <div class="input">
          <!-- <template v-if="formData.id">
            {{ formData["code"] }}
          </template>
          <template v-else> -->
          <el-input v-model="formData['code']"></el-input>
          <!-- </template> -->
        </div>
      </el-form-item>
      <el-form-item :label="language('shopCampaign.nameChi')" prop="name">
        <div class="input">
          <el-input v-model="formData['name']"></el-input>
        </div>
      </el-form-item>
      <el-form-item :label="language('shopCampaign.nameEng')" prop="nameEn">
        <div class="input">
          <el-input v-model="formData['nameEn']"></el-input>
        </div>
      </el-form-item>

      <el-form-item :label="language('shopCategory.thumb')" prop="thumb">
        <div class="input">
          <cc-uploader
            :config="uploaderConf"
            fType="image"
            v-model="formData['thumb']"
            :fFormatV2="['.jpg', '.png']"
          />
        </div>
      </el-form-item>

      <!-- <el-form-item label="parentId">
        <div class="input">

          <el-select v-model="formData['parentId']" placeholder>
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item> -->
      <el-form-item :label="language('shopCategory.isShow')" prop="isShow">
        <div class="input">
          <el-select v-model="formData['isShow']" placeholder="">
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item :label="language('shopCampaign.sort')" prop="sort">
        <div class="input">
          <el-input
            v-model="formData['sort']"
            @input="input_floor_num"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">{{
          language("shopCampaign.save")
        }}</el-button>
      </el-form-item>
    </el-form>
    <template v-if="formData.id">
      <div>Product (s) in Campaign</div>
      <el-divider></el-divider>
      <div class="count_tips">
        <div>
          <el-button type="primary" @click="addToCam">{{
            language("shopCampaign.addToCam")
          }}</el-button>
          <el-button type="primary" @click="addInBatch">{{
            language("shopCampaign.addInBatch")
          }}</el-button>
          <el-button type="primary" @click="topInBatch">{{
            language("shopCampaign.topInBatch")
          }}</el-button>
          <el-button type="danger" @click="deleteBatch">{{
            language("shopCampaign.deleteInBatch")
          }}</el-button>
        </div>
      </div>
      <cc-table
        :loadData="true"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        @selecting-result="contentSelect"
        :showIndex="false"
        :emptyText="language('shopCampaign.emptyText')"
      ></cc-table>
    </template>

    <!--手選導入-->
    <el-dialog
      :title="language('shopCampaign.content')"
      :visible.sync="adddialog"
      :close-on-click-modal="false"
      width="80%"
      append-to-body
    >
      <template v-if="adddialog">
        <cc-search
          :config="searchConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <cc-table
          :loadData="true"
          :config="contentTable"
          :params="contentParams"
          :refeshParams="contentRefeshTable"
          @submit-select="submitSelect"
          :emptyText="language('shopCampaign.emptyText')"
        ></cc-table>
      </template>
    </el-dialog>

    <!--文件導入-->
    <el-dialog
      :title="language('shopCampaign.import')"
      :visible.sync="importdialog"
      :close-on-click-modal="false"
      width="50%"
      append-to-body
    >
      <el-row>
        <el-col>
          <div class="file_box">
            <input type="file" @change="chenge" />
            <el-button>{{ language("shopCampaign.file") }}</el-button>
            {{ target }}
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col>
          <label class="label" style="margin-right: 10px">{{
            language("shopCampaign.downloadTemp")
          }}</label>
          <el-button type="primary" size="mini" @click="downloadTemp">{{
            language("shopCampaign.download")
          }}</el-button>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="importdialog = false">{{
          language("shopCampaign.cancel")
        }}</el-button>
        <el-button type="primary" @click="doSubmitBatch()">{{
          language("shopCampaign.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";

import axios from "axios";

export default {
  props: {
    editData: Object,
  },
  data() {
    return {
      uploaderConf: uploadUtils.configPublish,
      table: {
        api: "admin/merchant/tag/rel/query",
        showPager: true,
        selection: true,
        selectionNoSubmit: true,
        selectingResult: true,
        selectType: "Object",
        indexFixed: "left",
        columns: [
          {
            minWidth: 110,
            prop: "objData.saleStatus",
            lable: "Displayed",
            type: "tag",
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.saleStatus;
              }
            },
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
            },
          },
          {
            minWidth: 120,
            prop: "objData.auditStatus",
            lable: "Status",
            type: "tag",
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.auditStatus;
              }
            },
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "objData.type",
            lable: "type",
            type: "tag",
            minWidth: 190,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "objData.barcode",
            lable: "SKU ID（Barcode）",
            minWidth: 150,
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.barcode;
              }
            },
          },
          {
            prop: "objData.name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.name;
              }
            },
          },
          {
            prop: "objData.categories",
            lable: "Category（System）",
            minWidth: 120,
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.categories;
              }
            },
          },
          {
            prop: "objData.brand",
            lable: "Brand",
            minWidth: 120,
            render: (rows) => {
              if (rows.objData) {
                return rows.objData.brand;
              }
            },
          },
          {
            prop: "objData.listPrice",
            lable: "OriginalPrice",
            render: (rows) => {
              if (rows.objData) {
                return this.$utils.toFixedDigit(rows.objData.listPrice, 1);
              }
            },
            minWidth: 100,
          },
          // {
          //   prop: "updateAdminId",
          //   lable: "Update By",
          //   minWidth: 150,
          // },
          // {
          //   prop: "updateTime",
          //   lable: "Last Update",
          //   minWidth: 150,
          // },
          // {
          //   prop: "createTime",
          //   lable: "Create Date",
          //   minWidth: 150,
          // },
        ],
        buttons: [],
      },
      params: {},
      refeshTable: -1,
      formData: {},
      status: [
        {
          label: this.language("shopCategory.visible"),
          value: 1,
        },
        {
          label: this.language("shopCategory.invisible"),
          value: 0,
        },
      ],
      rules: {
        code: [
          {
            required: true,
            message: this.language("shopCampaign.codeTips"),
            trigger: "blur",
          },
          { validator: this.validatePass2, trigger: "blur" },
        ],
        name: [
          {
            required: true,
            message: this.language("shopCampaign.nameChiTips"),
            trigger: "blur",
          },
        ],
        thumb: [
          {
            required: true,
            message: this.language("shopCampaign.thumbTips"),
            trigger: "blur",
          },
        ],
        isShow: [
          {
            required: true,
            message: this.language("shopCampaign.displayedTips"),
            trigger: "blur",
          },
        ],
      },
      contentData: [],
      adddialog: false,
      searchConfig: [
        {
          title: "SKU ID / Barcode",
          fieldName: "barcode",
          style: "text",
          displayName: "",
        },
        {
          title: "Product Name",
          fieldName: "name",
          style: "text",
          displayName: "",
        },
      ],
      contentTable: {
        api: "admin/merchant/product/query?status=1",
        showPager: true,
        selection: true,
        selectType: "Object",
        selectingResult: true,
        selectionLabel: this.language("shopCampaign.addProduct"),
        indexFixed: "left",
        columns: [
          {
            minWidth: 110,
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            minWidth: 120,
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "type",
            minWidth: 190,
            type: "tag",
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "barcode",
            lable: "SKU ID（Barcode）",
            minWidth: 150,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "categories",
            lable: "Category（System）",
            minWidth: 120,
          },
          {
            prop: "brand",
            lable: "Brand",
            minWidth: 120,
          },
          {
            prop: "listPrice",
            lable: "OriginalPrice",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.listPrice, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminId",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [],
      },
      contentParams: {},
      contentRefeshTable: {},
      importdialog: false,
      target: "",
      importData: {},
      options: [],
    };
  },
  methods: {
    validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("Code is required"));
      } else if (!/^[A-Za-z0-9]*$/.test(value)) {
        callback(
          new Error(this.language("shopCampaign.onlyNumberAndCharacterTips"))
        );
      } else {
        callback();
      }
    },
    getData() {
      let e = {};
      e.shopNum = this.$shopData.shopNum;
      e.mchShopNum = this.$shopData.shopNum;
      this.ccRequest
        .do("admin/merchant/tag/query?pageSize=100000", e)
        .then((res) => {
          let options = [
            {
              name: "頂級",
              id: 0,
            },
          ];
          for (let i = 0; i < res.rows.length; i++) {
            if (res.rows[i].id != this.editData.id) {
              options.push(res.rows[i]);
            }
          }
          this.options = options;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });
    },
    input_floor_num(value) {
      if (value % 1 != 0 || isNaN(value)) {
        this.$alert(
          this.language("shopCampaign.inputErrorTips"),
          this.language("common.tips"),
          {
            confirmButtonText: this.language("common.confirm"),
            callback: (action) => {
              this.formData.sort = "";
            },
          }
        );
      }
      if (value > 0 || value < 0) {
        this.formData.sort = Math.floor(value);
      }
    },
    input_floor_num_2(value) {
      if (value % 1 != 0 || isNaN(value)) {
        this.$alert(
          this.language("shopCampaign.inputErrorTips"),
          this.language("common.tips"),
          {
            confirmButtonText: "確認",
            callback: (action) => {
              this.formData.parentId = "";
            },
          }
        );
      }
      if (value > 0 || value < 0) {
        this.formData.parentId = Math.floor(value);
      }
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let data = { ...this.formData };
          data.shopNum = this.$shopData.shopNum;
          data.mchShopNum = this.$shopData.shopNum;
          data.type="SHOP"
          this.ccRequest
            .do("admin/merchant/tag/save", data, "POSTJSON")
            .then((res) => {
              this.formData = res;
              this.params.tagId = res.id;
              this.$emit("success", true);
              this.$message({
                type: "success",
                message: this.language("shopCampaign.success"),
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    contentSelect(e) {
      this.contentData = e;
    },
    doSearch(e) {
      this.contentParams = {
        ...e,
        mchShopNum: this.$shopData.shopNum,
        shopNum: this.$shopData.shopNum,
      };
    },
    addToCam() {
      this.adddialog = true;
    },

    //手選導入
    submitSelect(e) {
      let data = [];
      for (let i = 0; i < e.length; i++) {
        data.push({
          tagId: this.formData.id,
          objId: e[i].mb1ProductId,
          objType: "product",
          appId: "supnr",
          shopNum: this.$shopData.shopNum,
          mchShopNum: this.$shopData.shopNum,
        });
      }
      this.$confirm(
        this.language("shopCampaign.addToCampaignTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.ccRequest
            .do("admin/merchant/tag/rel/batchSave", data, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopCampaign.addAudit"),
              });
              this.refeshTable = new Date().getTime();
              this.adddialog = false;
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },

    addInBatch() {
      this.importdialog = true;
      this.target = "";
      this.importData = {};
    },

    chenge(e) {
      console.log(e);
      if (
        e.target.files[0].name.indexOf(".xlsx") > 0 ||
        e.target.files[0].name.indexOf(".xls") > 0
      ) {
        this.target = e.target.value;
        this.importData.file = e.target.files[0];
      } else {
        this.$message.error(this.language("batchAddCard.xlsxErrorTips"));
        return false;
      }
    },
    downloadTemp() {
      window.open("/admin/merchant/file/downloadFile?code=tagUpload");
      this.$message(this.language("common.downloading"));
    },
    //以文件導入
    doSubmitBatch() {
      if (!this.importData.file) {
        this.$message.error(this.language("shopCategory.fileUploadTips"));
        return false;
      }
      this.$confirm(
        this.language("shopCategory.addBatchTips"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let formData = new FormData();
          formData.append("objType", "product");
          formData.append("file", this.importData.file);
          formData.append("appId", "supnr");
          formData.append("shopNum", this.$shopData.shopNum);
          formData.append("mchShopNum", this.$shopData.shopNum);

          axios({
            url: "/admin/merchant/tag/rel/import",
            method: "POST",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then((res) => {
              this.importdialog = false;
              this.refeshTable = new Date().getTime();
              this.$message({
                type: "success",
                message: this.language("shopCampaign.success"),
              });
            })
            .catch((err) => {
              var data = err.response.data;
              this.$message.error(data.message);
            });
        })
        .catch(() => {});
    },

    //刪除
    deleteBatch(e) {
      if (this.contentData.length == 0) {
        this.$message.error(this.language("shopCategory.chooseProductTips"));
        return false;
      }
      this.$confirm(
        this.language("shopCategory.deleteInBatches"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let data = {
            ids: [],
            tagId: this.formData.id,
            appId: "supnr",
          };
          for (let i = 0; i < this.contentData.length; i++) {
            data.ids.push(this.contentData[i].objId);
          }
          this.ccRequest
            .do("admin/merchant/tag/rel/batchDeleteRel", data, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopCategory.success"),
              });
              this.refeshTable = new Date().getTime();
              this.contentData = [];
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
    //置頂
    topInBatch() {
      if (this.contentData.length == 0) {
        this.$message.error(this.language("shopCategory.chooseProductTips"));
        return false;
      }
      this.$confirm(
        this.language("shopCategory.pinInBatches"),
        this.language("common.tips"),
        {
          confirmButtonText: this.language("common.confirm"),
          cancelButtonText: this.language("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let data = [];
          for (let i = 0; i < this.contentData.length; i++) {
            data.push({
              tagId: this.formData.id,
              objId: this.contentData[i].objId,
              objType: "product",
              appId: "supnr",
            });
          }
          this.ccRequest
            .do("admin/merchant/tag/rel/batchUpdateRelSort", data, "POSTJSON")
            .then((res) => {
              this.$message({
                type: "success",
                message: this.language("shopCategory.success"),
              });
              this.refeshTable = new Date().getTime();
              this.contentData = [];
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.params = {
      mchShopNum: this.$shopData.shopNum,
      shopNum: this.$shopData.shopNum,
      isAsc: true
    };
    this.contentParams = {
      shopNum: this.$shopData.shopNum,
      mchShopNum: this.$shopData.shopNum,
    };
    if (this.editData.id) {
      this.params.tagId = this.editData.id;
      this.formData = { ...this.editData };
    }

    let url = "/perm/campaign/";
    if (this.editData.id) {
      url = "/perm/campaign/" + this.editData.id + "/";
    }
    this.uploaderConf = uploadUtils.configPublishV2(url);
    // console.log(this.uploaderConf);
    this.getData();
  },
};
</script>
<style scoped>
.input {
  width: 400px;
}
.count_tips {
  margin: 10px 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file_box {
  position: relative;
}
.file_box input {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
</style>
<style lang="scss">
.campaign {
  .upload-btnV2 .upload-demo {
    margin-top: -21px !important;
  }
}
</style>
